'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.isThisMonth;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isThisMonth.js
// module id = 555
// module chunks = 0